// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2eDGT","paramInput":"JobSimulator_paramInput__3CpXP","input":"JobSimulator_input__3l_we"};